var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCbcRedcrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93807 0.913923C9.7329 0.816842 11.8477 1.9555 13.2824 4.3299C14.3491 6.42493 14.3589 8.52555 13.3118 10.6318C12.2779 12.4332 10.7421 13.5572 8.70447 14.0036C6.03153 14.3856 3.85788 13.5267 2.18351 11.4269C0.841687 9.48444 0.557103 7.39362 1.32975 5.15445C2.15717 3.14886 3.60464 1.81879 5.67215 1.16423C6.09202 1.04855 6.51402 0.965116 6.93807 0.913923Z",
    fill: "#F9EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0237 4.71273C5.16831 4.69986 5.30568 4.72439 5.43586 4.78635C6.11828 5.47388 6.80523 6.1561 7.49666 6.83299C8.18809 6.1561 8.87504 5.47388 9.55746 4.78635C9.95487 4.6268 10.2002 4.7544 10.2935 5.16918C10.293 5.2688 10.2684 5.36206 10.2199 5.44893C9.53253 6.13154 8.85049 6.81868 8.17378 7.5103C8.85049 8.20192 9.53253 8.88906 10.2199 9.57167C10.3808 9.98597 10.2434 10.2314 9.8077 10.3079C9.71559 10.3129 9.63215 10.2884 9.55746 10.2342C8.87504 9.54673 8.18809 8.8645 7.49666 8.18761C6.80523 8.8645 6.11828 9.54673 5.43586 10.2342C5.02167 10.3952 4.77635 10.2578 4.69986 9.82198C4.69483 9.72983 4.71935 9.64638 4.77346 9.57167C5.4608 8.88906 6.14283 8.20192 6.81954 7.5103C6.14283 6.81868 5.4608 6.13154 4.77346 5.44893C4.62302 5.12206 4.70643 4.87664 5.0237 4.71273Z",
    fill: "#FD2D35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbcRedcrossIcon);
export default __webpack_public_path__ + "static/media/cbc-redcross-icon.cd20850ece50525f40969c0a46135f48.svg";
export { ForwardRef as ReactComponent };